// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"735":"block12","981":"block0"}[chunkId] + "." + {"735":"627550a5","981":"f1da1030"}[chunkId] + ".css";
};